export const plotHeader = {
  fontSize: '0.9em',
  fontWeight: 700,
  width: '100%',
  textAlign: 'left',
  marginTop: 0,
  marginBottom: 0,
  paddingTop: '10px',
  paddingBottom: '10px',
};

export const timeAxisStyle = {
  label: {},
  values: {
    'font-size': 10,
    'font-family': 'Flanders Art Sans',
    color: '#8b7f7e',
    fill: '#8b7f7e',
  },
  ticks: {},
  axis: {},
};

export const trackerStyle = {
  line: {
    stroke: '#777',
    strokeWidth: '5px',
    cursor: 'crosshair',
    pointerEvents: 'none',
  },
};

export const yAxisStyle = {
  label: {
    fontWeight: 400,
    'font-size': 10,
    'font-family': 'Flanders Art Sans',
  },
  values: {
    'font-size': 10,
    'font-family': 'Flanders Art Sans',
    color: '#8b7f7e',
    fill: '#8b7f7e',
  },
  ticks: {},
  axis: {},
};
